export default __webpack_public_path__ + "static/media/SR.72d8e0b8.svg";